import styled from 'styled-components'
import { ToggleButtonUnstyled } from './unstyled'

export const ToggleButton = styled(ToggleButtonUnstyled)`
  button {
    border: 1px solid ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};
    &.Mui-selected,
    &.Mui-selected:hover,
    &:hover {
      background-color: ${props => props.theme.colors.primary};
      color: #fff;
    }
  }
`
